const DEFAULT_IMAGE = '/static/img/assessment/emailscams.svg';

/**
 * Maps LLM module JSON to an in-memory AwareGo question object.
 * @param {object} module - { presentation, blocks }
 * @param {object} meta - generation metadata
 */
export function mapAiToQuestion(module, meta = {}) {
    const { presentation, blocks } = module;
    const actions = {};
    const correctAnswers = {};
    const explanations = {};

    const uiBlocks = (blocks || []).map((block, index) => {
        const actionId = `radio${index + 1}`;
        const correctValue = block.correctValue;
        correctAnswers[actionId] = correctValue;
        explanations[actionId] = block.explanation || '';

        const values = {};
        (block.options || []).forEach((opt) => {
            const score = opt.value === correctValue ? 100 : 0;
            values[opt.value] = [{ score, component: 'knowledge' }];
        });
        actions[actionId] = { values };

        const correctOption = (block.options || []).find(
            (o) => o.value === correctValue
        );
        const correctText = correctOption ? correctOption.text : '';

        return {
            type: 'radio',
            actionId,
            title: block.title || '',
            pretitle: '',
            description: block.description || '',
            markdown: true,
            rawText: true,
            options: (block.options || []).map((o) => ({
                text: o.text,
                value: o.value,
            })),
            answer: {
                heading: [
                    {
                        text: block.explanation || correctText,
                        prefix: '',
                        scoreFrom: 0,
                        scoreTo: 100,
                    },
                ],
            },
            _correctValue: correctValue,
            _correctText: correctText,
        };
    });

    const id = `demo-${Date.now()}`;

    const definition = {
            type: 1,
            ui: {
                title: '',
                markdown: true,
                rawText: true,
                minimumBlockCount: uiBlocks.length,
                presentation: {
                    type: 'illustration',
                    title: presentation.title || meta.topic || 'OWASP Training',
                    pretitle: presentation.pretitle || '',
                    description: presentation.description || '',
                    image: presentation.image || DEFAULT_IMAGE,
                    markdown: true,
                    rawText: true,
                },
                blocks: uiBlocks,
            },
            actions,
            difficulty: (meta.difficulty || 'intermediate').toLowerCase(),
            adminDescription: 'AI-generated OWASP training demo module',
    };

    return {
        id,
        name: `OWASP ${meta.topic || 'Training'} (${meta.role || 'Demo'})`,
        definition,
        ui: definition.ui,
        correctAnswers,
        explanations,
        meta,
    };
}

export function scoreQuestion(question, blockValues) {
    const blocks = question?.definition?.ui?.blocks || [];
    const results = blocks.map((block) => {
        const actionId = block.actionId;
        const userValue = blockValues[actionId];
        const correctValue = question.correctAnswers[actionId];
        const correct = userValue === correctValue;
        const userOption = (block.options || []).find((o) => o.value === userValue);
        const correctOption = (block.options || []).find(
            (o) => o.value === correctValue
        );
        return {
            actionId,
            title: block.title,
            userValue,
            userText: userOption ? userOption.text : '—',
            correctValue,
            correctText: correctOption ? correctOption.text : '—',
            correct,
            score: correct ? 100 : 0,
            explanation: question.explanations[actionId] || block.answer?.heading?.[0]?.text || '',
        };
    });

    const totalScore =
        results.length > 0
            ? Math.round(
                  results.reduce((sum, r) => sum + r.score, 0) / results.length
              )
            : 0;

    return { results, totalScore, correctCount: results.filter((r) => r.correct).length };
}
